export const PROFILE_DETAILS = "PROFILE_DETAILS";
export const ACCOUNT_CONFIRMATION = "ACCOUNT_CONFIRMATION";
